import { CypressAttribute } from '@/test-utils/constants/CypressAttribute';

export class ReferralCypressAttribute extends CypressAttribute {
  static inventoryCollapse: (type: string) => string = (type: string) =>
    `ReferralCypressAttribute:prefilling:views:INVENTORY_COLLAPSE:${type}`;

  static buttons = {
    COPY_REFERRAL_LINK: 'ReferralCypressAttribute:buttons:COPY_REFERRAL_LINK',
    SEND_REFERRAL: 'ReferralCypressAttribute:buttons:SEND_REFERRAL',
    EDIT_REFERRAL: 'ReferralCypressAttribute:buttons:EDIT_REFERRAL'
  };
  static views = {
    PARTNERSHIP_INVITATION_PAGE_TABLE: 'ReferralCypressAttribute:views:REFERRAL_PAGE_TABLE',
    TABLE_CREATED_AT_HEADER_TOOLTIP_ICON:
      'ReferralCypressAttribute:views:TABLE_CREATED_AT_HEADER_TOOLTIP_ICON',
    TABLE_CREATED_AT_HEADER_TOOLTIP_POPOVER:
      'ReferralCypressAttribute:views:TABLE_CREATED_AT_HEADER_TOOLTIP_POPOVER',
    TABLE_CLIENT_CELL_TEXT: 'ReferralCypressAttribute:views:TABLE_CLIENT_CELL_TEXT',
    TABLE_INVITED_BY_CELL_TEXT: 'ReferralCypressAttribute:views:TABLE_INVITED_BY_CELL_TEXT',
    FINANCIAL_ADVISOR_PLANNING_FLOW_1:
      'ReferralCypressAttribute:views:FINANCIAL_ADVISOR_PLANNING_FLOW_1',
    FINANCIAL_ADVISOR_PLANNING_FLOW_1_V2:
      'ReferralCypressAttribute:views:FINANCIAL_ADVISOR_PLANNING_FLOW_1_V2',
    FINANCIAL_ADVISOR_PLANNING_FLOW_2:
      'ReferralCypressAttribute:views:FINANCIAL_ADVISOR_PLANNING_FLOW_2',
    FINANCIAL_ADVISOR_PLANNING_FLOW_3:
      'ReferralCypressAttribute:views:FINANCIAL_ADVISOR_PLANNING_FLOW_3',
    FREE_STANDARD_AVAILABLE_UNITS: 'ReferralCypressAttribute:views:FREE_STANDARD_AVAILABLE_UNITS',
    FREE_STANDARD_PLAN_TOTAL_UNITS: 'ReferralCypressAttribute:views:FREE_STANDARD_PLAN_TOTAL_UNITS',
    IS_FREE_STANDARD_PLAN: 'ReferralCypressAttribute:views:IS_FREE_STANDARD_PLAN',
    IS_SAAS_BILLING: 'ReferralCypressAttribute:views:IS_SAAS_BILLING',
    ADVISOR_PRO_BADGE: 'ReferralCypressAttribute:views:ADVISOR_PRO_BADGE',
    FREE_PRICE: 'ReferralCypressAttribute:views:FREE_PRICE'
  };
  static inputs = {
    USE_FREE_STANDARD_PLAN: 'ReferralCypressAttribute:inputs:USE_FREE_STANDARD_PLAN'
  };
  static form: CypressAttribute = {
    buttons: {
      PLAN_ACTION: 'ReferralCypressAttribute:form:buttons:PLAN_ACTION',
      CLOSE_MODAL: 'ReferralCypressAttribute:form:buttons:CLOSE_MODAL',
      INDIVIDUAL: 'ReferralCypressAttribute:form:buttons:INDIVIDUAL',
      COUPLES: 'ReferralCypressAttribute:form:buttons:COUPLES',
      LIGHT_DIAGNOSTIC_MATCH: 'ReferralCypressAttribute:form:buttons:LIGHT_DIAGNOSTIC_MATCH',
      CUSTOMIZED_SOLUTION_MATCH: 'ReferralCypressAttribute:form:buttons:CUSTOMIZED_SOLUTION_MATCH',
      BOOK_CONSULTATION: 'ReferralCypressAttribute:form:buttons:BOOK_CONSULTATION',
      DONT_SHOW_AGAIN: 'ReferralCypressAttribute:form:buttons:DONT_SHOW_AGAIN',
      SHARE_OWNERSHIP_TYPE: 'ReferralCypressAttribute:form:buttons:SHARE_OWNERSHIP_TYPE',
      SHARE_OWNERSHIP_TYPE_SOLE: 'ReferralCypressAttribute:form:buttons:SHARE_OWNERSHIP_TYPE_sole',
      SHARE_OWNERSHIP_TYPE_JOINT:
        'ReferralCypressAttribute:form:buttons:SHARE_ownership_TYPE_joint',
      SHARE_OWNERSHIP_TYPE_JOINT_WITH_SURVIVORSHIP_RIGHT:
        'ReferralCypressAttribute:form:buttons:SHARE_OWNERSHIP_TYPE_joint_with_survivorship_right'
    },
    inputs: {
      HAS_ADVISOR_ACKNOWLEDGMENT: 'ReferralCypressAttribute:form:inputs:HAS_ADVISOR_ACKNOWLEDGMENT'
    },
    views: {
      GUIDED_PLAN: 'ReferralCypressAttribute:form:views:GUIDED_PLAN',
      UNGUIDED_PLAN: 'ReferralCypressAttribute:form:views:UNGUIDED_PLAN',
      PLAN: 'ReferralCypressAttribute:form:views:PLAN',
      BOOK_CONSULTATION: 'ReferralCypressAttribute:form:views:BOOK_CONSULTATION',
      INDIVIDUAL_FORM: 'ReferralCypressAttribute:form:views:INDIVIDUAL_FORM',
      COUPLES_FORM: 'ReferralCypressAttribute:form:views:COUPLES_FORM',
      INVITE_SUCCESS_BANNER: 'ReferralCypressAttribute:form:views:INVITE_SUCCESS_BANNER',
      BOOK_MEETING_BANNER: 'ReferralCypressAttribute:form:views:BOOK_MEETING_BANNER',
      DIGITAL_VAULT_UPGRADE_TO_PRO_CARD:
        'ReferralCypressAttribute:form:views:DIGITAL_VAULT_UPGRADE_TO_PRO_CARD',
      VAULT_PLAN_SELECTION_MODAL: 'ReferralCypressAttribute:form:views:VAULT_PLAN_SELECTION_MODAL'
    }
  };
  static prefilling: CypressAttribute = {
    buttons: {
      CONTINUE_WITHOUT_FILLING:
        'ReferralCypressAttribute:prefilling:views:OPTION_WIDGET_CONTINUE_WITHOUT_FILLING',
      BACK_BUTTON: 'ReferralCypressAttribute:prefilling:buttons:BACK_BUTTON',
      NEXT_BUTTON: 'ReferralCypressAttribute:prefilling:buttons:NEXT_BUTTON',
      ADD_CONTACT_BUTTON: 'ReferralCypressAttribute:prefilling:buttons:ADD_CONTACT_BUTTON',
      VIEW_DETAILS_BUTTON: 'ReferralCypressAttribute:prefilling:buttons:VIEW_DETAILS_BUTTON',
      DELETE_CONTACT_BUTTON: 'ReferralCypressAttribute:prefilling:buttons:DELETE_CONTACT_BUTTON',
      SAVE_INVENTORY: 'ReferralCypressAttribute:prefilling:buttons:SAVE_INVENTORY',
      DELETE_INVENTORY: 'ReferralCypressAttribute:prefilling:buttons:DELETE_INVENTORY',
      ADD_INVENTORY: 'ReferralCypressAttribute:prefilling:buttons:ADD_INVENTORY'
    },
    inputs: {
      ASSET_NAME: 'ReferralCypressAttribute:prefilling:inputs:ASSET_NAME',
      CURRENT_VALUE: 'ReferralCypressAttribute:prefilling:inputs:CURRENT_VALUE',
      AT_DEATH_VALUE: 'ReferralCypressAttribute:prefilling:inputs:AT_DEATH_VALUE',
      PURCHASE_PRICE: 'ReferralCypressAttribute:prefilling:inputs:PURCHASE_PRICE',
      NAME: 'ReferralCypressAttribute:prefilling:inputs:NAME',
      CURRENCY_ID: 'ReferralCypressAttribute:prefilling:inputs:CURRENCY_ID'
    },
    views: {
      OPTION_WIDGET: 'ReferralCypressAttribute:prefilling:views:OPTION_WIDGET',
      OPTION: 'ReferralCypressAttribute:prefilling:views:OPTION',
      OPTION_IMAGE: 'ReferralCypressAttribute:prefilling:views:OPTION_IMAGE',
      PERSONAL_INFORMATION_STEP:
        'ReferralCypressAttribute:prefilling:views:PERSONAL_INFORMATION_STEP',
      PERSONAL_INFORMATION_FORM:
        'ReferralCypressAttribute:prefilling:views:PERSONAL_INFORMATION_FORM',
      CONTACTS_STEP: 'ReferralCypressAttribute:prefilling:views:CONTACTS_STEP',
      CONTACTS_TABLE: 'ReferralCypressAttribute:prefilling:views:CONTACTS_TABLE',
      INVENTORY_STEP: 'ReferralCypressAttribute:prefilling:views:INVENTORY_STEP',
      INVENTORY_FORM: 'ReferralCypressAttribute:prefilling:views:INVENTORY_FORM',
      SUMMARY_CONTACT_FIRST_NAME:
        'ReferralCypressAttribute:prefilling:views:SUMMARY_CONTACT_FIRST_NAME',
      SUMMARY_CONTACT_LAST_NAME:
        'ReferralCypressAttribute:prefilling:views:SUMMARY_CONTACT_LAST_NAME',
      SUMMARY_CONTACT_DATE_OF_BIRTH:
        'ReferralCypressAttribute:prefilling:views:SUMMARY_CONTACT_DATE_OF_BIRTH',
      SUMMARY_CONTACT_EMAIL: 'ReferralCypressAttribute:prefilling:views:SUMMARY_CONTACT_EMAIL',
      SUMMARY_CONTACT_PHONE_NUMBER:
        'ReferralCypressAttribute:prefilling:views:SUMMARY_CONTACT_PHONE_NUMBER',
      SUMMARY_CONTACT_ADDRESS: 'ReferralCypressAttribute:prefilling:views:SUMMARY_CONTACT_ADDRESS',
      SUMMARY_CONTACT_RELATIONSHIP_TYPE:
        'ReferralCypressAttribute:prefilling:views:SUMMARY_CONTACT_RELATIONSHIP_TYPE',
      SUMMARY_REFERRAL_PERSONAL_INFORMATION:
        'ReferralCypressAttribute:prefilling:views:SUMMARY_REFERRAL_PERSONAL_INFORMATION',
      SUMMARY_PARTNER_REFERRAL_CONTACT_INFORMATION:
        'ReferralCypressAttribute:prefilling:views:SUMMARY_PARTNER_REFERRAL_CONTACT_INFORMATION'
    }
  };

  static editModal: CypressAttribute = {
    buttons: {},
    inputs: {},
    views: {
      MODAL: 'ReferralCypressAttribute:editModal:views:MODAL',
      PARTNER_CLIENT_1_LABEL: 'ReferralCypressAttribute:editModal:views:PARTNER_CLIENT_1_LABEL',
      PARTNER_CLIENT_2_LABEL: 'ReferralCypressAttribute:editModal:views:PARTNER_CLIENT_2_LABEL',
      PRIMARY_CLIENT_FORM: 'ReferralCypressAttribute:editModal:views:PRIMARY_CLIENT_FORM',
      PARTNER_CLIENT_FORM: 'ReferralCypressAttribute:editModal:views:PARTNER_CLIENT_FORM'
    }
  };

  static postReferralCreationModal: CypressAttribute = {
    buttons: {
      CONTINUE_REFERRAL:
        'ReferralCypressAttribute:postReferralCreationModal:buttons:CONTINUE_REFERRAL',
      OPEN_CLIENT_FILE:
        'ReferralCypressAttribute:postReferralCreationModal:buttons:OPEN_CLIENT_FILE',
      MAKE_ANOTHER_REFERRAL:
        'ReferralCypressAttribute:postReferralCreationModal:buttons:MAKE_ANOTHER_REFERRAL'
    },
    inputs: {},
    views: {
      MODAL: 'ReferralCypressAttribute:postReferralCreationModal:views:MODAL',
      TITLE: 'ReferralCypressAttribute:postReferralCreationModal:views:TITLE'
    }
  };

  static inventoryCard: CypressAttribute = {
    buttons: {},
    inputs: {},
    views: {
      card: 'ReferralCypressAttribute:prefilling:inventoryCard:card',
      accountName: 'ReferralCypressAttribute:prefilling:inventoryCard:accountName',
      ownershipText: 'ReferralCypressAttribute:prefilling:inventoryCard:ownershipText',
      priceAmount: 'ReferralCypressAttribute:prefilling:inventoryCard:priceAmount',
      priceAmountSubLabel: 'ReferralCypressAttribute:prefilling:inventoryCard:priceAmountSubLabel',
      amount: 'ReferralCypressAttribute:prefilling:inventoryCard:amount',
      amountSubLabel: 'ReferralCypressAttribute:prefilling:inventoryCard:amountSubLabel',
      missingInfo: 'ReferralCypressAttribute:prefilling:inventoryCard:missingInfo'
    }
  };
}
